module.exports = __webpack_public_path__ + "static/logo-1009985a121f473191541156e10dfbce.ico";